import {Component, Inject, OnInit, Renderer2} from '@angular/core';
import {ItemGlSetupService} from '~/app/core/services/item-gl-setup.service';
import {UserService} from '~/app/core/services/user.service';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {ItemGLSetup} from '@model/ItemGLSetup';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {paths} from '~/app/app-paths';
import {Router} from '@angular/router';
import {HomeOffice} from '@model/HomeOffice';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {AddNewGlSetupComponent} from '~/app/web/accounting/accounts-payable/add-new-gl-setup/add-new-gl-setup.component';
import {EditService} from '~/app/core/services/edit.service';
import {GridDataResult} from '@progress/kendo-angular-grid';
import {process, State} from '@progress/kendo-data-query';
import { Observable, lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-item-gl-setup',
  templateUrl: './item-gl-setup.component.html',
  styleUrls: ['./item-gl-setup.component.scss']
})
export class ItemGlSetupComponent implements OnInit {
  public gridData: any = [];
  public mySelection: ItemGLSetup[] = [];
  public selectedCallback = (args) => args.dataItem;
  public itemGlList: ItemGLSetup[] = [];
  public itemGlListUpdates: ItemGLSetup[] = [];
  public itemGLSetup: ItemGLSetup = new ItemGLSetup();
  public selectedHomeOffice: HomeOffice;
  public selectedGLCodes: any[] = [];
  private glCode: string;
  public view: Observable<GridDataResult>;

  private editService: EditService;
  private editedRowIndex: number;
  private editedProduct: ItemGLSetup;

  public gridState: State = {
    sort: [],
    skip: 0,
    take: 20
  };


  constructor(public itemGlSetupService: ItemGlSetupService,
              public userService: UserService,
              public localStorage: LocalStorageIndexedService,
              public router: Router,
              public dialogService: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              private renderer: Renderer2,
              @Inject(EditService) editServiceFactory: () => EditService) {
              this.editService = editServiceFactory();
  }

  async ngOnInit() {
    this.view = this.editService.pipe(map(data => process(data, this.gridState)));
    this.populateInvoiceGrid();

    //  this.editService.read(this.selectedHomeOffice.hoId);
  }

  public onStateChange(state: State) {
    this.gridState = state;
    this.editService.read(this.selectedHomeOffice.hoId);
  }

  async populateInvoiceGrid() {
    this.loadingIndicator.show();
    if (this.userService.selectedHomeOffice === undefined) {
      if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== undefined && this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== null) {
        this.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        this.itemGlList = await this.itemGlSetupService.getItemsGlList(this.selectedHomeOffice.hoId);
        this.loadingIndicator.hide();
      } else {
        this.loadingIndicator.hide();
        this.dialogService.showErrorNotificationForDuration("No home office is selected.", 2000);
        await this.router.navigate([paths.home]);
      }
    } else {
      this.selectedHomeOffice = this.userService.selectedHomeOffice;
      this.itemGlList = await this.itemGlSetupService.getItemsGlList(this.selectedHomeOffice.hoId);
      this.loadingIndicator.hide();
    }

    this.mySelection = [];
    this.gridData = this.itemGlList;
    this.gridData.total = this.itemGlList.length;
    this.loadingIndicator.hide();
  }


  add() {
    const dialogRef = this.dialogService.open({
      type: DialogType.INFO,
      title: 'Add New',
      content: AddNewGlSetupComponent,
      actions: [
        {text: 'Cancel', primary: false},
        {text: 'Ok', themeColor:'primary' },
      ],
      width: 400
    });
    /** Setting disabled attribute in dialog button */
    setTimeout(() => {
      const buttons = Array.from(document.querySelectorAll('kendo-dialog-actions button'));
      buttons.forEach((button) => {
        if (button.textContent.trim() === 'Ok') {
          this.renderer.setAttribute(button, 'disabled', 'true');
        }
      });
    });

    const dialogContent = dialogRef.content.instance;
/** Listen  glCodeValid event from the child component */
dialogContent.glCodeValid.subscribe((isValid: boolean) => {
  setTimeout(() => {
    const buttons = Array.from(document.querySelectorAll('kendo-dialog-actions button'));
    buttons.forEach((button) => {
      if (button.textContent.trim() === 'Ok') {
        if (isValid) {
          this.renderer.removeAttribute(button, 'disabled');
        } else {
          this.renderer.setAttribute(button, 'disabled', 'true');
        }
      }
    });
  });
});

    dialogRef.result.subscribe(async (answer: any) => {
      let glCodeTextValue = dialogContent.newGlCodeTextValue;
      let glDescTextValue = dialogContent.newGlDescriptionTextValue;
      if (answer.text === 'Ok') {
        console.log(glCodeTextValue);
        console.log(glDescTextValue);
        this.itemGLSetup.glCode = glCodeTextValue;
        this.itemGLSetup.glDesc = glDescTextValue;
        this.itemGLSetup.hoId = +this.selectedHomeOffice.hoId;
        this.itemGLSetup.expGL = '';
        this.itemGLSetup.idealCost = false;
        this.itemGLSetup.dailyVariance = false;
        this.itemGLSetup.removable = true;
        this.itemGLSetup.codeModified = false;
        this.itemGLSetup.modified = false;
        lastValueFrom(this.itemGlSetupService.addItem(this.itemGLSetup)).then(() => {
          this.dialogService.showSuccessNotification('Add Successful');
          this.populateInvoiceGrid();
        });
      }
    });
  }


  delete() {
    if (this.mySelection.length > 0) {
      this.dialogService.openDialog({
        type: DialogType.INFO,
        title: 'Available Exports',
        content: 'Are you sure you want to delete selected?',
        actions: [
          {text: 'Cancel', primary: false},
          {text: 'Ok', primary: true},
        ],
        width: 400
      }).then(() => {
         var array = [];
        this.mySelection.forEach(gl => {
          array.push({'hoId': this.selectedHomeOffice.hoId, 'glCode': gl.glCode});
        });
        this.itemGlSetupService.delete(array)
          .subscribe(() => {
            this.populateInvoiceGrid().then(r => r);
            this.dialogService.showSuccessNotification('Delete Successful');
          });
      });
    } else {
      this.dialogService.showWarningNotification('Please select an item to delete');
    }
  }

  getItemsInGl() {
    // navigate to the item gl details screen
    // probably better to call this there....

    // TODO after i create the hyper link, call this method when hyperlink is clicked,
    // TODO store the HOID and GLCODE in localstorage
    // THEN ON DETAIL SCREEN
    // Retrieve info from local storage and populate screen
    // this.itemGlSetupService.setHoIdAndGlCode(this.selectedHomeOffice.hoId, this.glCode);

  }

  async goToItemDetails(dataItem) {
    // TODO save in local storage possible?
    this.localStorage.setToSession(AppEnums.GL_CODE, dataItem.glCode);
    console.log(dataItem.glCode);

    // navigate to the item details screen and call the APIs, with this info...
    this.router.navigate([paths.itemGlDetails]).then(r => r);
  }


  public editHandler({sender, rowIndex, dataItem}) {
    // close the previously edited item
    this.closeEditor(sender);

    // track the most recently edited row
    // it will be used in `closeEditor` for closing the previously edited row
    this.editedRowIndex = rowIndex;

    // clone the current - `[(ngModel)]` will modify the original item
    // use this copy to revert changes
    this.editedProduct = Object.assign({}, dataItem);

    // edit the row
    sender.editRow(rowIndex);
  }

  public addHandler({sender}, formInstance) {
    formInstance.reset();
    this.closeEditor(sender);

    sender.addRow(new ItemGLSetup());
  }


  public cancelHandler({sender, rowIndex}) {
    this.closeEditor(sender, rowIndex);
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    // close the editor
    grid.closeRow(rowIndex);

    // revert the data item to original state
    // this.editService.resetItem(this.editedProduct);

    // reset the helpers
    this.editedRowIndex = undefined;
    this.editedProduct = undefined;
  }

  public saveHandler({sender, rowIndex, dataItem, isNew}) {
    console.warn({sender, rowIndex, dataItem, isNew});
    // update the data source
    this.editService.save(dataItem, isNew).subscribe(() => {
      this.populateInvoiceGrid().then(r => r);
      this.dialogService.showSuccessNotification('Update Successful');
    });

    // close the editor, that is, revert the row back into view mode
    sender.closeRow(rowIndex);
  }


  public removeHandler({dataItem}) {
    // remove the current dataItem from the current data source
    // in this example, the dataItem is `editService`
    // this.editService.remove(dataItem);


    this.dialogService.openDialog({
      type: DialogType.INFO,
      title: 'Available Exports',
      content: 'Are you sure you want to delete selected?',
      actions: [
        {text: 'Cancel', primary: false},
        {text: 'Ok', primary: true},
      ],
      width: 400
    }).then((answer) => {
      if (answer === 'Ok') {
        var array = [];

        array.push({'hoId': this.selectedHomeOffice.hoId, 'glCode': dataItem.glCode});

        this.itemGlSetupService.delete(array)
          .subscribe(() => {
            this.populateInvoiceGrid().then(r => r);
            this.dialogService.showSuccessNotification('Delete Successful');
          });
      } else {

      }
    });
  }
}
